import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
// Hanken Grotesk — a fonte da LP (design system v2), servida pelo próprio bundle.
import '@fontsource/hanken-grotesk/400.css';
import '@fontsource/hanken-grotesk/500.css';
import '@fontsource/hanken-grotesk/600.css';
import '@fontsource/hanken-grotesk/700.css';
import '@fontsource/hanken-grotesk/800.css';
import './styles/index.css';
import { initLocalStorageDebug } from './utils/localStorage-debug';
import { initAuthStorageAdapter } from './lib/auth-storage-adapter';

// Initialize auth storage adapter to intercept localStorage calls
initAuthStorageAdapter();
console.log('[Main] Auth storage adapter initialized');

// Initialize localStorage debug utilities in development
if (import.meta.env.DEV) {
  initLocalStorageDebug();
  // Auth debugger auto-initializes when imported
  console.log('[Main] Auth debug utilities initialized');
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);